module.exports = __webpack_public_path__ + "static/media/server3.3f4127da.jpg";